export const downloadBlob = (blob, filename) => {
  if (navigator.appVersion.toString().indexOf(".NET") > 0) {
    //For IE just download the file...
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    return url;
  }
};
